import { Component, inject, viewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApmTranslatePipe, RouteFacade } from '@mitsubishi/core';
import { ButtonComponent } from '@mitsubishi/shared/ui';

import { ChillerFreeStDataSheetPreviewComponent } from '../../components/chiller-free-st-data-sheet-preview/chiller-free-st-data-sheet-preview.component';
import { ChillerFreeStDataSheetWorkingConditionsComponent } from '../../components/chiller-free-st-data-sheet-working-conditions/chiller-free-st-data-sheet-working-conditions.component';
import { ChillerFreeStDataSheetStore } from '../../stores/chiller-free-st-data-sheet.store';
import { ChillerFreeStStore } from '../../stores/chiller-free-st.store';

@Component({
  selector: 'apm-chiller-free-st-data-sheet',
  imports: [
    ChillerFreeStDataSheetWorkingConditionsComponent,
    ChillerFreeStDataSheetPreviewComponent,
    ButtonComponent,
    ApmTranslatePipe,
  ],
  providers: [ChillerFreeStStore, ChillerFreeStDataSheetStore],
  templateUrl: './chiller-free-st-data-sheet.component.html',
  styleUrl: './chiller-free-st-data-sheet.component.scss',
})
export class ChillerFreeStDataSheetComponent {
  readonly mainStore = inject(ChillerFreeStStore);
  readonly store = inject(ChillerFreeStDataSheetStore);
  readonly #route = inject(ActivatedRoute);
  readonly #routeFacade = inject(RouteFacade);
  readonly workingConditionsComp = viewChild.required(ChillerFreeStDataSheetWorkingConditionsComponent);

  constructor() {
    // La scheda si apre in un tab nuovo con la URL completa, quindi :projectId e sempre in rotta.
    this.mainStore.setProjectId(this.#routeFacade.projectId);
    const configurationId = this.#route.snapshot.paramMap.get('configurationId')!;
    this.store.loadConfiguration(configurationId);
  }

  updateDatasheet(): void {
    this.workingConditionsComp().updateDatasheet();
  }
}
